import React, { Component } from 'react';
import Pictogram from './pictogram';
import TranslatedCopy from '../../intl/translated-copy';
import cx from 'classnames';

import gifPayment from '../../../images/loadingConfirmationPayment.gif';

class LoadingScreen extends Component {
  /**
   * @param {Object} props - Properties for LoadingScreen component
   * @param {Boolean} props.isDataLoading - Determines if loading screen should be rendered
   */

  static defaultProps = {
    type: 'loader',
  }
  render() {
    const {
      ancillary,
      type,
      isPayment,
      isSendEmail,
    } = this.props;

    let {
      className,
    } = this.props;

    className = cx({
      'LoadingScreen': !ancillary,
      'LoadingScreen__Ancillary': ancillary,
      'LoadingScreen__ModalSendEmail': isSendEmail,
    }, className);

    return (
      <div key='loading-screen' className={ className }>
        <div className={ !ancillary ? isPayment ? 'LoadingScreen-wrapper LoadingScreen-wrapper--payment' : 'LoadingScreen-wrapper' : null }>
          { type === 'airplaneWindow' && this.renderLoadingComponentAirplaneWindow() }
          { type === 'gifAnimated' && isPayment && this.renderLoadingGifAnimated() }
        </div>
      </div>
    );
  }

  renderLoadingComponentAirplaneWindow() {
    const numWindows = 3;
    const airplaneWindowList = [];

    for (let i = 0; i < numWindows; i++) {
      airplaneWindowList.push(this.renderAirplaneWindow(i));
    }

    return (
      <div className='LoadingScreen-wrapAirplaneWindow'>
        { airplaneWindowList }
      </div>
    );
  }

  renderAirplaneWindow(index) {
    const classLoading = this.props.seatmap ? 'LoadingScreen-airplaneWindow--seatmap' : 'LoadingScreen-airplaneWindow';
    return (
      <div className={classLoading} key={ index }>
        <div className='LoadingScreen-wrapAirplaneWindowCloud'>
          { !this.props.seatmap ?
            <Pictogram
              className='LoadingScreen-airplaneWindowCloudSmall'
              id='cloudSmall' /> : null
          }
        </div>
        <div className='LoadingScreen-wrapAirplaneWindowCloud'>
          { !this.props.seatmap ?
            <Pictogram
              className='LoadingScreen-airplaneWindowCloudSmall'
              id='cloud' /> : null
          }
        </div>
        <div className='LoadingScreen-wrapAirplaneWindowCloud'>
          { !this.props.seatmap ?
            <Pictogram
              className='LoadingScreen-airplaneWindowCloudSmall'
              id='cloud' /> : null
          }
        </div>
      </div>
    );
  }

  renderLoadingGifAnimated() {
    return (
      <div className='LoadingScreen-gifAnimated'>
        <div className='LoadingScreen-gifAnimated-wrapper'>
          <TranslatedCopy
            className='LoadingScreen-gifAnimated-header'
            copyID='MYB_PAYMENTS_PROCESSING_YOUR_PURCHASE'
            tagName='h2'
          />
          <img
            alt='Loading'
            className='LoadingScreen-gifAnimated-img'
            src={ gifPayment }
          />
          <TranslatedCopy
            className='LoadingScreen-gifAnimated-title'
            copyID='MYB_PAYMENTS_DO_NOT_CLOSE_WINDOW'
            tagName='p'
          />
          <TranslatedCopy
            className='LoadingScreen-gifAnimated-subtitle'
            copyID='MYB_PAYMENTS_REDIRECT_TO_CONFIRMATION'
            tagName='p'
          />
        </div>
      </div>
    );
  }

  renderCopy() {
    const copyIDList = ['PO_LOAD_MSG1', 'PO_LOAD_MSG3' ];

    return (
      <div>
        { copyIDList.map((copyID, i) => {
          return (
            <div key={i} className={ `LoadingScreen-wrapCopy LoadingScreen-wrapCopy--${ i }` }>
              <TranslatedCopy
                className='LoadingScreen-copy'
                copyID={ copyID }
                tag='div' />
            </div>
          );
        }) }
      </div>
    );
  }
}

export default LoadingScreen;